import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";

import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";
import { deleteTuition, getTuitions, importExcel } from "../../../../services/TuitionService";

const TuitionHistoryList = () => {
  const [tuitionList, setTuitionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchTuition();
  }, []);

  const fetchTuition = async () => {
    try {
      const data = await getTuitions();
      setTuitionList(data);
    } catch (error) {
      console.error("Error fetching tuition list:", error);
    }
  };

  const handleDelete = async (email, year) => {
    try {
      await deleteTuition(email, year);
      fetchTuition(); // Refresh list after deletion
      console.log("tuition deleted successfully");
    } catch (error) {
      console.error("Error deleting tuition:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "email", title: "Email" },
    { prop: "year", title: "Year" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={"/settings/tuition/"+row.email +"/" + row.year}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row.email,row.year)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = tuitionList.map((tuition) => ({
    email: tuition.email,
    year: tuition.year,
    createdAt: new Date(tuition.createdAt).toLocaleString(),
    updatedAt: new Date(tuition.updatedAt).toLocaleString(),
  }));

  // Filter the data based on the tuitionhistory label
  const filteredData = tableData.filter(
    (item) =>
      item.email.toLowerCase().includes(filterText.toLowerCase())
  );

  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setMessage(""); // Clear previous messages
  };

    // Handle file upload
    const handleUpload = async () => {
      if (!selectedFile) {
        setMessage("Please select a file to upload.");
        return;
      }
  
      const formData = new FormData();
      formData.append("file", selectedFile);
  
      try {
        const response = await importExcel(formData);
        setMessage(response);
      } catch (error) {
        console.error("Upload error:", error);
        setMessage("Error uploading file.");
      }
    };

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Tuition Amount List</h4>
            <Link
              variant="primary"
              to={"/settings/tuition/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Tuition</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Employee Email"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
                <Col md={7} lg={7} >
              <Form className="d-flex align-items-center">
                <Form.Group controlId="formFile" className="mb-0 mr-2">
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "inline-block", width: "auto" }}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  onClick={handleUpload}
                  className="ml-2"
                  style={{marginLeft: "5px", marginRight: "5px"}}
                >
                  Upload
                </Button>
                {message && <span className="" style={{"marginLeft": "10px"}}>{message}</span>}
              </Form>
             
            </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default TuitionHistoryList;
